import React from "react";
import {
    TableRow,
    TableCell,
    Typography,
    Tooltip,
    IconButton,
    Box
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import { useAtom } from "jotai";
import moment from "moment";
import {
    openViewWebhookModalAtom,
    selectedWebhookAtom,
    WEBHOOK_EVENT_TYPE_LABELS
} from "../../atoms/webhooks";

export const WebhookRow = ({ webhook }) => {
    const theme = useTheme();
    const [, setOpenViewModal] = useAtom(openViewWebhookModalAtom);
    const [, setSelectedWebhook] = useAtom(selectedWebhookAtom);

    const { id, name, eventType, url, status, createdAt } = webhook;

    const isActive = status === "active";

    const handleViewClick = (event) => {
        event.stopPropagation();
        setSelectedWebhook(webhook);
        setOpenViewModal(true);
    };

    const handleRowClick = () => {
        setSelectedWebhook(webhook);
        setOpenViewModal(true);
    };

    const truncateUrl = (url, maxLength = 50) => {
        if (!url) return "";
        return url.length > maxLength
            ? url.substring(0, maxLength) + "..."
            : url;
    };

    return (
        <TableRow key={id} hover onClick={handleRowClick}>
            <TableCell
                sx={{
                    width: "1%",
                    textAlign: "center"
                }}
            >
                <Tooltip
                    componentsProps={{
                        tooltip: {
                            sx: {
                                fontWeight: 400,
                                fontSize: "14px !important"
                            }
                        }
                    }}
                    title={isActive ? "Active" : "Inactive"}
                >
                    <CircleIcon
                        sx={{
                            fontSize: "1.05rem",
                            color: isActive
                                ? theme.palette.verified
                                : grey[300]
                        }}
                    />
                </Tooltip>
            </TableCell>
            <TableCell sx={{ width: "25%" }}>
                <Box>
                    <Typography variant="body1" fontWeight={500}>
                        {name}
                    </Typography>
                </Box>
            </TableCell>
            <TableCell sx={{ width: "15%" }}>
                <Typography variant="body1">
                    {WEBHOOK_EVENT_TYPE_LABELS[eventType] || eventType}
                </Typography>
            </TableCell>
            <TableCell sx={{ width: "30%" }}>
                <Tooltip title={url}>
                    <Typography
                        variant="body1"
                        sx={{
                            color: theme.palette.text.secondary,
                            fontFamily: "monospace",
                            fontSize: "13px"
                        }}
                    >
                        {truncateUrl(url)}
                    </Typography>
                </Tooltip>
            </TableCell>
            <TableCell sx={{ width: "15%" }}>
                <Typography>
                    {moment(createdAt).format("MMM DD, Y")}
                    <br />
                    <Typography
                        component="span"
                        textTransform={"uppercase"}
                        sx={{ fontSize: "12px", color: grey[500] }}
                    >
                        {moment(createdAt).format("h:mm a")}
                    </Typography>
                </Typography>
            </TableCell>
            <TableCell sx={{ width: "5%", textAlign: "center" }}>
                <Tooltip title="View Details">
                    <IconButton
                        size="small"
                        onClick={handleViewClick}
                        sx={{ color: theme.palette.primary.main }}
                    >
                        <VisibilityIcon />
                    </IconButton>
                </Tooltip>
            </TableCell>
        </TableRow>
    );
};
